<template>
    <form @submit.prevent="submit">
        <p v-if="error !== null" class="flash-error">
            {{ error }}
        </p>

        <p class="form-group">
            <label for="sales_item_name">Namn</label>
            <input type="text" name="name" id="sales_item_name" v-model="salesItem.name" required>
        </p>

        <p class="form-group">
            <label for="sales_item_description">Beskrivning</label>
            <textarea name="description" id="sales_item_description" v-model="salesItem.description"></textarea>
        </p>

        <p class="form-actions">
            <button type="submit">Spara</button>
        </p>
    </form>
</template>

<script>
export default {
    name: 'SalesItemForm',
    props: ['salesItem'],
    data: function () {
        return {
            error: null
        };
    },
    methods: {
        submit() {
            this.error = null;

            if (this.salesItem.name === '') {
                this.error = 'Namn är obligatoriskt';
                return;
            }

            this.$emit('submit');
        }
    }
}
</script>
